export default {"src":"/_next/static/media/onboarding2.9aaec955.svg","height":434,"width":399,"blurWidth":0,"blurHeight":0};